/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Listen_To_Any_EmailInputs */

const en_common_listen_to_any_email = /** @type {(inputs: Common_Listen_To_Any_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen to any email or newsletter`)
};

const es_common_listen_to_any_email = /** @type {(inputs: Common_Listen_To_Any_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escucha cualquier correo o newsletter`)
};

/**
* | output |
* | --- |
* | "Listen to any email or newsletter" |
*
* @param {Common_Listen_To_Any_EmailInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_listen_to_any_email = /** @type {((inputs?: Common_Listen_To_Any_EmailInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Listen_To_Any_EmailInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_listen_to_any_email(inputs)
	return en_common_listen_to_any_email(inputs)
});